import request from '@/utils/request'
// 获取当前用户详情
export function getPresentUserInfo(query) {
  return request({
    url: '/app-api/service/user/getPresentUserInfo/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取用户系统消息列表
export function getAppSysMsgList(query) {
  return request({
    url: '/app-api/service/user/getAppSysMsgList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取常见问题列表
export function getFaqList(query) {
  return request({
    url: '/app-api/service/common/getFaqList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 提交问题反馈
export function submitFeedback(data) {
  return request({
    url: '/app-api/service/common/submitFeedback/v1_0_0',
    method: 'post',
    data: data
  })
}
// 修改密码
export function updatePassWord(data) {
  return request({
    url: '/app-api/service/user/updatePassWord/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取静态页面内容
export function getHtmlContentByType(query) {
  return request({
    url: '/app-api/service/common/getHtmlContentByType/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取用户虚拟币账单列表
export function getBalanceBillList(query) {
  return request({
    url: '/app-api/service/user/getBalanceBillList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 修改用户资料
export function updUserInfo(data) {
  return request({
    url: '/app-api/service/user/updUserInfo/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取未读消息数量
export function getMsgUnreadCount(query) {
  return request({
    url: '/app-api/service/user/getMsgUnreadCount/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取app下载配置
export function getAppDownloadConfig(query) {
  return request({
    url: '/app-api/service/common/getAppDownloadConfig/v1_0_0',
    method: 'get',
    params: query
  })
}

// 获取流水记录列表
export function getFlowRecordList(query) {
  return request({
    url: '/app-api/service/user/getFlowRecordList/v1_0_0',
    method: 'get',
    params: query
  })
}

// 获取APP配置信息
export function getAppConfigInfo(query) {
  return request({
    url: '/app-api/service/common/getAppConfigInfo',
    method: 'get',
    params: query
  })
}
// 删除粉丝
export function deleteVermicelli(data) {
  return request({
    url: '/app-api/service/user/deleteVermicelli/v1_0_0',
    method: 'post',
    data: data
  })
}
// 关注或取消关注
export function followOrCancelFollow(data) {
  return request({
    url: '/app-api/service/user/followOrCancelFollow/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取当前用户关注的列表
export function getUserFollowList(query) {
  return request({
    url: '/app-api/service/user/getUserFollowList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取当前用户粉丝列表
export function getUserVermicelliList(query) {
  return request({
    url: '/app-api/service/user/getUserVermicelliList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 添加或取消收藏视频
export function addCollectOrCancelCollectVideo(data) {
  return request({
    url: '/app-api/service/video/addCollectOrCancelCollectVideo/v1_0_0',
    method: 'post',
    data: data
  })
}
// 添加或取消点赞视频
export function addGiveLikeOrCancelGiveLikeVideo(data) {
  return request({
    url: '/app-api/service/video/addGiveLikeOrCancelGiveLikeVideo/v1_0_0',
    method: 'post',
    data: data
  })
}
// 评论视频
export function commentVideo(data) {
  return request({
    url: '/app-api/service/video/commentVideo/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取子级评论列表(不需要登录)
export function getChildCommentList(query) {
  return request({
    url: '/app-api/service/video/getChildCommentList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取用户收藏的视频列表(需要登录)
export function getUserCollectVideoList(query) {
  return request({
    url: '/app-api/service/video/getUserCollectVideoList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取用户点赞的视频列表(需要登录)
export function getUserGiveLikeVideoList(query) {
  return request({
    url: '/app-api/service/video/getUserGiveLikeVideoList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取视频评论列表(不需要登录)
export function getVideoCommentList(query) {
  return request({
    url: '/app-api/service/video/getVideoCommentList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取平台短影音列表(不需要登录,只返回审核通过的)
export function getVideoList(query) {
  return request({
    url: '/app-api/service/video/getVideoList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 回复评论
export function replyCommentVideo(data) {
  return request({
    url: '/app-api/service/video/replyCommentVideo/v1_0_0',
    method: 'post',
    data: data
  })
}
// 删除评论(支持删除回复)
export function deleteComment(data) {
  return request({
    url: '/app-api/service/video/deleteComment/v1_0_0',
    method: 'post',
    data: data
  })
}
// 查看他人的短影音列表(不需要登录,只返回审核通过的)
export function viewUserVideoList(query) {
  return request({
    url: '/app-api/service/video/viewUserVideoList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 查看用户详情
export function viewUserInfo(query) {
  return request({
    url: '/app-api/service/user/viewUserInfo/v1_0_0',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js